import { useEffect, useRef } from "react";
import { Section, Footer } from "./Landing";
import { Button } from "../components/ui/button";
import { useSEO, SEO_PRESETS } from "@/hooks/useSEO";

const LegalHeader = () => {
  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-white/80 backdrop-blur-xl supports-[backdrop-filter]:bg-white/60 shadow-sm">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <div className="flex items-center gap-3">
          <div className="relative">
            <img 
              src="/images/logo-klartech.png" 
              alt="Klartech Müritz Logo" 
              className="h-12 w-auto object-contain transition-transform hover:scale-105"
            />
            <div className="absolute -right-1 -top-1 h-3 w-3 rounded-full bg-green-500 animate-pulse ring-2 ring-white"></div>
          </div>
        </div>
        <nav className="flex items-center gap-8">
          <Button
            onClick={() => window.location.href = '/'}
            className="relative rounded-xl bg-gradient-to-r from-primary to-blue-600 px-6 py-2.5 text-white shadow-lg transition-all hover:shadow-xl hover:scale-105 group overflow-hidden"
          >
            <span className="relative z-10 font-semibold">← Zur Startseite</span>
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-primary opacity-0 transition-opacity group-hover:opacity-100"></div>
          </Button>
        </nav>
      </div>
    </header>
  );
};

export default function Datenschutz() {
  useSEO(SEO_PRESETS.datenschutz);
  const widgetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Create the PrivacyBee widget element dynamically
    if (widgetRef.current && widgetRef.current.children.length === 0) {
      const widget = document.createElement('privacybee-widget');
      widget.setAttribute('website-id', 'cmkc875xn00hyvy2vmydk4jj6');
      widget.setAttribute('type', 'dsgvo');
      widget.setAttribute('lang', 'de');
      widgetRef.current.appendChild(widget);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white text-slate-900">
      <LegalHeader />
      <Section id="datenschutz" className="pt-10">
        <h1 className="text-3xl font-extrabold tracking-tight mb-8">Datenschutzerklärung</h1>
        
        {/* PrivacyBee Widget Container */}
        <div className="prose prose-slate max-w-none" ref={widgetRef} />
      </Section>
      <Footer />
    </div>
  );
}
